import { kebabCase } from "lodash";
import { PasskeySite, RequestedSite } from "../components";

export const directoryRecordKey = (
  record: PasskeySite | RequestedSite
): string => {
  return record.name ? kebabCase(record.name) : "";
};
